import Cookies from 'js-cookie';

const EXTERNAL_LOGOUT_URLS = {
  eng: 'https://marivalagents.com/user/logout',
  esp: 'https://marivalagents.com/user/cerrar-sesion',
};

export function getExternalLogoutUrl(language = Cookies.get('language')) {
  return EXTERNAL_LOGOUT_URLS[language] || EXTERNAL_LOGOUT_URLS.eng;
}

// Cierra la sesion del sitio marivalagents.com en segundo plano (POST) segun el
// idioma activo. Es fire-and-forget: no bloquea ni afecta el logout local, y
// `keepalive` permite que la peticion termine aunque la pagina redirija justo
// despues. `no-cors` + `credentials: 'include'` envian la cookie de sesion de
// ese dominio sin exigir cabeceras CORS en la respuesta (que no necesitamos leer).
export function notifyExternalLogout() {
  const url = getExternalLogoutUrl();

  if (typeof fetch !== 'function') {
    return;
  }

  try {
    fetch(url, {
      method: 'POST',
      mode: 'no-cors',
      credentials: 'include',
      keepalive: true,
    }).catch(() => {});
  } catch (error) {
    // Nunca debe romper el flujo de logout local.
  }
}
